const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  emptyGrid: {
    height: "76px",
    textAlign: "center",
  },
  topGrid: {
    borderBottom: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "76px"
  },
  middleGrid: {
    textAlign: "center",
    height: "75px",
    borderBottom: "0.5px solid #D3D3D3"
  },
  middleLGrid: {
    textAlign: "center",
    height: "76px",
    borderBottom: "0.5px solid #D3D3D3",
    borderRight: "0.5px solid #D3D3D3",
    maxWidth: "49%"
  },
  middleRGrid: {
    textAlign: "center",
    height: "76px",
    borderBottom: "0.5px solid #D3D3D3"
    //borderLeft: "0.5px solid #D3D3D3"
  },
  bottomGrid: {
    textAlign: "center",
    height: "76px"
  },
  t_tar_text: {
    fontSize: "11pt",
    marginTop: theme.spacing.unit * 2
  },
  t_tar_no: {
    fontSize: "12pt"
  },
  t_tar_no2: {
    fontSize: "15pt",
    fontWeight: "bold"
  },
  t_tar_no3: {
    fontSize: "11pt"
  },
  t_tar_text_p: {
    fontSize: "12pt",
    color: `${theme.palette.success} !important`,
    marginTop: theme.spacing.unit * 3
  },
  t_tar_no_p: {
    fontSize: "15pt",
    color: `${theme.palette.success} !important`,
    fontWeight: "bold"
  },
  t_tar_text_f: {
    fontSize: "12pt",
    color: `${theme.palette.fail} !important`,
    marginTop: theme.spacing.unit * 3
  },
  t_tar_no_f: {
    fontSize: "15pt",
    color: `${theme.palette.fail} !important`,
    fontWeight: "bold"
  }
});

export default styles;
